import { PageLoader } from '@innovationnorway/component-library';
import { FC } from 'react';
import { useLocalizer } from '../../../hooks';

export const LoadingSpinner: FC = () => {
  const { globalL } = useLocalizer('Global');

  return (
    <div className='w-full flex flex-row my-20 mx-0 justify-center'>
      <PageLoader className="bg-white" aria-label={globalL('loadingSpinner')} />
    </div>
  );
};
